export default "/images/45c5003865d8807fc3b4ffc16f5db8a5.avif";